import React, { useCallback, useRef, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import InputValidationTooltip from "../../common/InputValidationTooltip";
import { notAllowedAddressCharsGlobalRegex } from "constants/validations";

interface AddressFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    id?: string;
    className?: string;
}

const AddressField = ({ register, error, id, className = "" }: AddressFieldProps) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const tooltipTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            const validValue = value.replace(notAllowedAddressCharsGlobalRegex, "");

            if (value !== validValue && value.length > 0) {
                inputRef.current = e.target;
                setShowTooltip(true);

                if (tooltipTimeoutRef.current) clearTimeout(tooltipTimeoutRef.current);

                tooltipTimeoutRef.current = setTimeout(() => {
                    setShowTooltip(false);
                }, 2000);
            }

            if (validValue.length <= 30) {
                e.target.value = validValue;
                if (register.onChange) {
                    register.onChange(e);
                }
            }
        },
        [register]
    );

    return (
        <div className="form-control">
            <label className="label h-7" htmlFor={id}>
                <span className="text-base-content">Home Address</span>
            </label>
            <input
                {...register}
                onChange={handleChange}
                ref={(e) => {
                    if (register.ref) {
                        register.ref(e);
                    }
                    inputRef.current = e;
                }}
                id={id}
                type="text"
                placeholder="123 Main Street"
                className={`input input-bordered bg-base-100 h-9 text-sm ${error ? "input-error" : ""} ${className}`}
                maxLength={30}
            />
            <InputValidationTooltip message="Cannot contain special characters" show={showTooltip} targetRef={inputRef} />
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default AddressField;
